module.exports = __webpack_public_path__ + "media/alerta1.29dd3710.mp3";